import { z } from 'zod'
import { ThemeChoices } from '../pages/systemTheme/types'

export const userSchema = z
  .object({
    cpf: z.string().min(1, { message: 'CPF é um campo obrigatório' }),
    fullName: z.string().min(1, {
      message: 'Nome é um campo obrigatório',
    }),
    email: z
      .string()
      .min(1, { message: 'Email é um campo obrigatório' })
      .email({ message: 'Email inválido' }),
    password: z.string().min(1, { message: 'Senha é um campo obrigatório' }),
    confirmPassword: z.string(),
    acceptTerm: z.boolean().refine((data) => data, {
      message: 'Você precisa aceitar os termos',
    }),
  })
  .refine(
    (data) => {
      return data.password === data.confirmPassword
    },
    {
      message: 'As senhas não conferem',
      path: ['confirmPassword'],
    }
  )

export const companySchema = z.object({
  name: z.string().min(1, { message: 'Nome é um campo obrigatório' }),
  cnpj: z.string(),
  system: z.string({ message: 'Sistema é um campo obrigatório' }),
  email: z
    .string()
    .min(1, { message: 'Email é um campo obrigatório' })
    .email({ message: 'Email inválido' }),
  phone: z.string().min(1, { message: 'Telefone é um campo obrigatório' }),
})

export const credentialsSchema = z.record(z.string())

export const themeSchema = z.object({
  theme: z.enum(Object.values(ThemeChoices) as [string, ...string[]]),
})

export const customThemeSchema = z.record(z.string())
